export default __webpack_public_path__ + "static/media/desk_myst.89829ff8.png";